import React from 'react';
import ReactDOM from 'react-dom/client';
import '/node_modules/bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './fonts/SFProDisplay-Black.eot';
import './fonts/SFProDisplay-Black.ttf';
import './fonts/SFProDisplay-Black.woff';
import './fonts/SFProDisplay-Black.woff2';

import './fonts/SFProDisplay-BlackItalic.eot';
import './fonts/SFProDisplay-BlackItalic.ttf';
import './fonts/SFProDisplay-BlackItalic.woff';
import './fonts/SFProDisplay-BlackItalic.woff2';

import './fonts/SFProDisplay-Bold.eot';
import './fonts/SFProDisplay-Bold.ttf';
import './fonts/SFProDisplay-Bold.woff';
import './fonts/SFProDisplay-Bold.woff2';

import './fonts/SFProDisplay-BoldItalic.eot';
import './fonts/SFProDisplay-BoldItalic.ttf';
import './fonts/SFProDisplay-BoldItalic.woff';
import './fonts/SFProDisplay-BoldItalic.woff2';

import './fonts/SFProDisplay-Heavy.eot';
import './fonts/SFProDisplay-Heavy.ttf';
import './fonts/SFProDisplay-Heavy.woff';
import './fonts/SFProDisplay-Heavy.woff2';

import './fonts/SFProDisplay-HeavyItalic.eot';
import './fonts/SFProDisplay-HeavyItalic.ttf';
import './fonts/SFProDisplay-HeavyItalic.woff';
import './fonts/SFProDisplay-HeavyItalic.woff2';

import './fonts/SFProDisplay-Light.eot';
import './fonts/SFProDisplay-Light.ttf';
import './fonts/SFProDisplay-Light.woff';
import './fonts/SFProDisplay-Light.woff2';

import './fonts/SFProDisplay-LightItalic.eot';
import './fonts/SFProDisplay-LightItalic.ttf';
import './fonts/SFProDisplay-LightItalic.woff';
import './fonts/SFProDisplay-LightItalic.woff2';

import './fonts/SFProDisplay-Medium.eot';
import './fonts/SFProDisplay-Medium.ttf';
import './fonts/SFProDisplay-Medium.woff';
import './fonts/SFProDisplay-Medium.woff2';

import './fonts/SFProDisplay-MediumItalic.eot';
import './fonts/SFProDisplay-MediumItalic.ttf';
import './fonts/SFProDisplay-MediumItalic.woff';
import './fonts/SFProDisplay-MediumItalic.woff2';

import './fonts/SFProDisplay-Regular.eot';
import './fonts/SFProDisplay-Regular.ttf';
import './fonts/SFProDisplay-Regular.woff';
import './fonts/SFProDisplay-Regular.woff2';

import './fonts/SFProDisplay-RegularItalic.eot';
import './fonts/SFProDisplay-RegularItalic.ttf';
import './fonts/SFProDisplay-RegularItalic.woff';
import './fonts/SFProDisplay-RegularItalic.woff2';

import './fonts/SFProDisplay-Semibold.eot';
import './fonts/SFProDisplay-Semibold.ttf';
import './fonts/SFProDisplay-Semibold.woff';
import './fonts/SFProDisplay-Semibold.woff2';

import './fonts/SFProDisplay-SemiboldItalic.eot';
import './fonts/SFProDisplay-SemiboldItalic.ttf';
import './fonts/SFProDisplay-SemiboldItalic.woff';
import './fonts/SFProDisplay-SemiboldItalic.woff2';

import './fonts/SFProDisplay-Thin.eot';
import './fonts/SFProDisplay-Thin.ttf';
import './fonts/SFProDisplay-Thin.woff';
import './fonts/SFProDisplay-Thin.woff2';

import './fonts/SFProDisplay-ThinItalic.eot';
import './fonts/SFProDisplay-ThinItalic.ttf';
import './fonts/SFProDisplay-ThinItalic.woff';
import './fonts/SFProDisplay-ThinItalic.woff2';

import './fonts/SFProDisplay-Ultralight.eot';
import './fonts/SFProDisplay-Ultralight.ttf';
import './fonts/SFProDisplay-Ultralight.woff';
import './fonts/SFProDisplay-Ultralight.woff2';

import './fonts/SFProDisplay-UltralightItalic.eot';
import './fonts/SFProDisplay-UltralightItalic.ttf';
import './fonts/SFProDisplay-UltralightItalic.woff';
import './fonts/SFProDisplay-UltralightItalic.woff2';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
reportWebVitals();
